<template>
  <b-sidebar
    id="sidebar-form-exam-check"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t(examCheck.id ? 'Update': 'Create') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="examCheckValidation">
          <!-- Category Subject Id -->
          <validation-provider
            #default="{ errors }"
            :name="$t('Status')"
            rules="required"
          >
            <b-form-group
              :label="$t('Status')"
              label-for="status"
            >
              <v-select
                id="status"
                v-model="examCheck.status"
                :reduce="(option) => option.id"
                :options="additionalExamCheckStatus"
                :get-option-label="(option) => $langName(option)"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>

          <validation-provider
            #default="{ errors }"
            :name="$t('Score')"
            rules="required|integer|min_value:0"
          >
            <b-form-group
              :label="$t('score')"
              label-for="score"
            >
              <b-form-input
                v-model="examCheck.score"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>

          <validation-provider
            #default="{ errors }"
            :name="$t('Comment')"
            rules=""
          >
            <b-form-group
              :label="$t('Comment')"
              label-for="comment"
            >
              <b-form-textarea
                v-model="examCheck.comment"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>

        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="examCheck.id ? 'primary' : 'success'"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t(examCheck.id ? 'Update': 'Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton,
  BFormInput, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, integer, minValue } from '@/libs/validations/validations'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
    ValidationObserver,
    ValidationProvider,
    BFormInput,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      minValue,
    }
  },
  computed: {
    examCheck() {
      return this.$store.state[this.MODULE_NAME].examCheck
    },
    additionalExamCheckStatus() {
      return this.$store.state.staticModule.additionalExamCheckStatus
    },
  },
  created() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      hide()
    },
    submit(hide) {
      this.$refs.examCheckValidation.validate().then(success => {
        if (success) {
          let data = this.examCheck
          if (typeof data.apply_doc === 'object') {
            data.apply_doc = data.apply_doc.id
          }
          if (this.examCheck.id) {
            data = {
              id: this.examCheck.id,
              body: this.examCheck,
            }
          }
          this.$createSwal(this, data, `${this.MODULE_NAME}/${this.examCheck.id ? 'patch' : 'create'}`, () => {
            this.$emit('refetchTables')
          })
          hide()
        }
      })
    },
  },
  setup() {
    const MODULE_NAME = 'additionalExamCheck'
    return {
      MODULE_NAME,
    }
  },
}
</script>
